import 'nsw-design-system/src/components/content-block/_content-block.scss';
import './content-container.scss';
import { div as divElem } from '../../scripts/dom-helpers.js';
import { createOptimizedPicture } from '../../scripts/aem.js';

function decorateImageColumn(imageColumn) {
  // Make the first column the image container if there is an image
  if (imageColumn.querySelector('picture')) {
    imageColumn.className = 'nsw-content-block__image';
  }
}

function decorateTextColumn(textColumn) {
  textColumn.classList.add('nsw-content-block__content');
  [...textColumn.children].forEach((child) => {
    if (/^H[1-6]$/.test(child.tagName)) {
      child.classList.add('nsw-content-block__title');
    } else if (child.tagName === 'P') {
      const hasAnchorTag = child.querySelector('a') !== null;
      if (hasAnchorTag) {
        child.classList.add('nsw-content-block__link');
      } else {
        child.classList.add('nsw-content-block__copy');
      }
    }
  });
}

export default function decorate(block) {
  const grid = divElem({ class: 'nsw-grid' });
  [...block.children].forEach((contentBlock) => {
    contentBlock.classList.add('nsw-col', 'nsw-col-md-6', 'nsw-col-lg-4');
    const [imageColumn, textColumn] = contentBlock.children;
    decorateImageColumn(imageColumn);
    decorateTextColumn(textColumn);
    grid.append(contentBlock);
  });

  // SWS-1515 - focal point implementation
  grid.querySelectorAll('picture > img').forEach((img) => {
    let [x, y] = [50, 50];
    const { title } = img.dataset;
    if (title?.includes('data-focal')) {
      delete img.dataset.title;
      [x, y] = title.split(':')[1].split(',');
    }
    const optimizedPic = createOptimizedPicture(img.src, img.alt, false, [
      { width: '750' },
    ]);
    const optimizedImg = optimizedPic.querySelector('img');
    optimizedImg.style.objectPosition = `${x}% ${y}%`;
    img.closest('picture').replaceWith(optimizedPic);
  });

  block.textContent = '';
  block.append(grid);
}
